import { CheckboxChangeEvent } from "antd/lib/checkbox"
import { Key, useEffect, useState } from "react"
import { CheckboxItem } from "../../../../../../../../_webui/layout/components/RowSelection/CheckboxItem"
import { TableRowSelection } from "../../../../../../../../_webui/layout/components/Table/models"
import { Translate } from "../../../../../../../../constant/Translate"
import { FilesListDataSourceType } from "../../../../../models/files/list"
import { useTable } from "../../../../../../../../utils/hook/useTable"

const { TEXT_T023 } = Translate

export const useRowSelection = (fileInfoList: FilesListDataSourceType[]) => {
  const [isDisabledBtnDownload, setIsDisabledBtnDownload] = useState(true)
  const [isDisabledBtnPreview, setIsDisabledBtnPreview] = useState(true)
  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([])

  const { onChange: onChangePage, perItem } = useTable(fileInfoList.length)

  const onSelectChange = () => {
    const _isDisabledBtnDownload = !selectedRowKeys.length
    const _isDisabledBtnPreview = selectedRowKeys.length !== 1
    setIsDisabledBtnDownload(_isDisabledBtnDownload)
    setIsDisabledBtnPreview(_isDisabledBtnPreview)
  }

  const onChangeCheckItem = (event: CheckboxChangeEvent) => {
    const checked = event.target.checked
    const value = event.target.value

    if (checked) setSelectedRowKeys([...selectedRowKeys, value])
    else {
      const _selectedRowKeys = selectedRowKeys.filter((item) => item !== value)
      setSelectedRowKeys(_selectedRowKeys)
    }
  }

  const rowSelection: TableRowSelection<FilesListDataSourceType> = {
    columnTitle: <div className="d-none">{TEXT_T023}</div>,
    hideSelectAll: true,
    renderCell: (_, record) => (
      <CheckboxItem
        checked={selectedRowKeys.includes(record.uploadId)}
        onChange={onChangeCheckItem}
        value={record.uploadId}
      />
    ),
    selectedRowKeys,
  }

  const onChangePagination = (page: number, pageSize: number) => {
    onChangePage(page, pageSize)
    setSelectedRowKeys([])
  }

  const onChangeTable = () => {
    setSelectedRowKeys([])
  }

  useEffect(() => {
    onSelectChange()
  }, [selectedRowKeys])

  return {
    isDisabledBtnDownload,
    isDisabledBtnPreview,
    onChangePagination,
    onChangeTable,
    perItem,
    rowSelection,
    selectedRowKeys,
    setIsDisabledBtnDownload,
    setIsDisabledBtnPreview,
    setSelectedRowKeys,
  }
}
